import React, { useState, useEffect } from 'react'
import { Container } from '@sainsburys-tech/luna-react'

import BannerApi from '../../../api/bannerApi';
import { useApiClient } from '../../../context/AppContext';

import  {Banner}  from './../../../types/Entities/BannerType'

const HelpdeskBanner = () => {

    const apiClient = useApiClient();
    const [banner, setBanner] = useState([{}] as Banner[])

    useEffect(() => {
        fetchData()
        const interval = setInterval(() => {
            fetchData()
          }, 300000);
          return () => clearInterval(interval);
    },[])

    const fetchData = () => {
        return BannerApi.getBannerData(apiClient)
            .then(res => { return res})
            .then((res) => {
                if(res){
                    setBanner(res)
                }
            })
            .catch((err) => {
                
            })
    }
    return(
        <>
        {banner.length > 0 && (
            // <Container className='helpdesk-banner' fluid size='lg'>
                <div className="bg_color_white bdr_C_W_S risk-banner" style={{padding:'10px'}}>
                    {/* <ul> */}
                        {banner.map(x => (
                            <li>{x.notes}</li>
                        ))}
                    {/* </ul> */}
                </div>
            // </Container>
        )}
        </>
    )
}

export default HelpdeskBanner
